module.exports = __webpack_public_path__ + "media/src/assets/fonts/mplus-1p-regular-16159c5f8d8bed43944cc7c4111e9bf8.ttf";